import script from "./ColorButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorButton.vue?vue&type=script&lang=ts&setup=true"

import "./ColorButton.vue?vue&type=style&index=0&id=ed8f2044&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed8f2044"]])

export default __exports__